<template>
	<section>
		<bread-crumb></bread-crumb>
		<progress-bar :order_status='order_status'></progress-bar>
		<div class="wrap">
			<follow class="follow" ref="follow"></follow>
			<add-follow-cost class="add-follow-cost" @addFollow="addFollow"></add-follow-cost>
		</div>
	</section>
</template>

<script>
	import BreadCrumb from '@/components/BreadCrumb.vue';
	import ProgressBar from './components/progressBar.vue';
	import Follow from './components/follow.vue';
	import AddFollowCost from './components/addFollowCost.vue';
	export default {
		components: {
			BreadCrumb,
			ProgressBar,
			Follow,
			AddFollowCost
		},

		data() {
			return {
				order_status: this.$route.query.order_status,
				order_uuid: this.$route.query.order_uuid
			};
		},

		methods: {
			addFollow() {
				this.$refs.follow.getOrderFollow();
			}
		}
	};
</script>

<style lang="scss" scoped>
	.wrap {
		display: flex;
		justify-content: space-between;

		.follow {
			width: 50%;
		}

		.add-follow-cost {
			width: 48%;
		}
	}
</style>
